import {useMutation} from "@apollo/client";
import {yupResolver} from "@hookform/resolvers/yup";
import pick from "lodash/pick";
import {FormProvider, useForm} from "react-hook-form";
import * as Yup from "yup";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {
  GQL_PRIVATE_LOCATIONS_LIST_QUERY,
  GQL_UPDATE_PRIVATE_LOCATION,
  UpdatePrivateLocationResult,
} from "@/lib/queries/monitoring.ts";
import {ResponseStatus} from "@/lib/types/common.ts";
import {PrivateLocation} from "@/lib/types/monitoring.ts";

interface PrivateLocationFormFields {
  id?: number;
  name: string;
}

type PrivateLocationFormKeys = keyof PrivateLocationFormFields;

interface PrivateLocationFormProps {
  location: PrivateLocation;
  formId?: string;
  onSave?: () => void;
}

export const PrivateLocationForm = ({formId, location, onSave}: PrivateLocationFormProps) => {
  const form = useForm<PrivateLocationFormFields>({
    resolver: yupResolver<PrivateLocationFormFields>(
      Yup.object({
        id: Yup.number().optional(),
        name: Yup.string().max(50).required("This field cannot be blank."),
      })
    ),
    defaultValues: location,
  });

  const [updatePrivateLocation] = useMutation<UpdatePrivateLocationResult>(GQL_UPDATE_PRIVATE_LOCATION, {
    refetchQueries: [GQL_PRIVATE_LOCATIONS_LIST_QUERY],
  });

  const onSubmit = async (locationData: PrivateLocationFormFields) => {
    const resp = await updatePrivateLocation({
      variables: {data: pick(locationData, ["id", "name"])},
    });

    if (resp.data?.response?.status === ResponseStatus.SUCCESS) {
      if (onSave) onSave();
    } else {
      if (resp.data?.response?.message) {
        Object.entries(resp.data.response.message).forEach(([fieldName, messageList]) => {
          form.setError(fieldName as PrivateLocationFormKeys, {message: (messageList as string[])[0]});
        });
      }
    }
  };

  return (
    <FormProvider {...form}>
      <form id={formId} onSubmit={form.handleSubmit(onSubmit)} noValidate>
        <div className="d-flex align-items-center justify-items-center gap-2">
          <InputField name={"name"} label={"Name"} required={true} maxLength={50} className="w-100" />
        </div>
      </form>
    </FormProvider>
  );
};
